// extracted by mini-css-extract-plugin
export default {"typewriter":"Hero_typewriter__cGaJe","typing":"Hero_typing__nijHX","blink-caret":"Hero_blink-caret__tEzX3"};